import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { PermissionService } from 'src/app/permission/permission.service';
import { RoutingService } from '../../../../../services/routing.service';
import { UnitBankAccountReqRes } from '../../../../models/gp/UnitBankAccountReqRes.model';
import { PaymentReadDto } from '../models/payment/payment-read-dto.model';

@Component({
  selector: 'terra-unit-payment-recipient-details',
  templateUrl: './unit-payment-recipient-details.component.html',
  styleUrls: ['./unit-payment-recipient-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitPaymentRecipientDetailsComponent {
  @Input() payment: PaymentReadDto;
  @Input() sourceBankAccount: UnitBankAccountReqRes;
  @Input() isGp:boolean;

  private readonly routingService = inject(RoutingService);
  private readonly permissionService = inject(PermissionService);

  get typeOfPayment(): string {
    return `${(this.payment?.destinationUnitBankAccountId && '(Internal)') || ''}`;
  }

  /**
   * Concat recipient first and last names
   */
  get unitContactName(): string {
    return `${this.sourceBankAccount.unitApplication?.contact?.fullName?.first} ${this.sourceBankAccount.unitApplication?.contact?.fullName?.last}`;
  }

  get iconName(): string {
    return this.payment?.destinationUnitBankAccountId ? `attach_money` : `person`;
  }

  get linkToBankAccountPage(): string {
    if (!!this.payment?.destinationUnitBankAccountId) {
      if(this.isGp){
        return this.routingService.creBankAccountPage(this.payment.destinationUnitBankAccountId);
      }
      else{
        return this.routingService.lpUnitBankAccount(this.payment.destinationUnitBankAccountId);
      }
    }
    return ``;
  }

  get recipientTitle(): string {
    if (!!this.payment?.recipient) {
      return `Recipient`;
    } else if (!!this.payment?.destinationUnitBankAccountId) {
      return `Account`;
    } else {
      return ``;
    }
  }

  get recipientName$(): Observable<string> {
    return this.permissionService.allowInvestorName$
    .pipe(
      startWith(''),
      map(allow => {
          if (!!this.payment?.recipient) {
            if(allow) {
              return `${this.payment.recipient.firstName} ${this.payment.recipient.lastName}`;
            }
            return `${this.payment.recipient.nickname}`;
          }
      
          if (!!this.payment?.destinationUnitBankAccountAccountNickname) {
            return `${this.payment.destinationUnitBankAccountAccountNickname}`;
          }

          return '';
      })
    );
  }
}
